
import { Toast } from '@tencent/pmd-widget/lib/toast';
import { getCompressImgUrl, getCdnUrl } from '@tencent/pmd-tools/lib/image';
import { reportClick, reportPageExposure, reportPageDuration, reportCustomData } from 'src/local-logic/tip-match/report/report';
import { isHor, insertHorClass, isPC } from 'src/local-logic/utils/hor';
import { initShare, openShareUI } from '@tencent/pmd-widget/lib/share';
import { addAdtag } from 'src/local-logic/tip-match/share';
import { isInAcceleratorApp, clientShare } from 'src/local-logic/tip-match/room/accelerator-app-tools.js';
import { ConfigInfo } from '@tencent/pmd-config/lib/project';
import { getUrlPath } from 'src/local-logic/utils/url/url';
// #ifdef H5
import { navigateData } from '@tencent/press-plus/common/page-animation/index';
// #endif

function getPageOptions() {
  const pages = getCurrentPages();
  return pages[pages.length - 1]?.options || {};
}

const isMPQQ = process.env.UNI_PLATFORM === 'mp-qq';
const isMPWeixin = process.env.UNI_PLATFORM === 'mp-weixin' || isMPQQ;

let wxMpVersion = 'prod';

// #ifdef MP-WEIXIN || MP-QQ
if (typeof __wxConfig === 'object') {
  // eslint-disable-next-line no-undef
  const version = __wxConfig.envVersion;
  console.log(`当前环境: ${version}`);
  if (version == 'develop') {
    // 工具或者真机 开发环境
    wxMpVersion = 'dev';
  } else if (version == 'trial') {
    // 测试环境(体验版)
    wxMpVersion = 'trial';
  } else if (version == 'release') {
    // 正式环境
    wxMpVersion = 'prod';
  }
}
// #endif

export const projectMixins = {
  data() {
    return {
      isMPWeixin,
      isMpWeixin: isMPWeixin,
      isMPQQ,
      _gMpShareObj: {
        title: '王者赛宝',
        path: '',
      },
      wxMpVersion,
    };
  },
  computed: {
    isHor() {
      return isHor();
    },
    isPC() {
      return isPC();
    },
    // #ifndef H5
    $route() {
      let route = app.$router?.route;
      // #ifdef H5
      route = route?.value;
      // #endif
      return route;
    },
    // #endif
  },
  options: {
    pureDataPattern: /^_/,  // 小程序指定所有 _ 的数据字段为纯数据字段
  },
  onShareAppMessage() { // 发送给朋友
    this.$data._gMpShareObj.path = this.$data._gMpShareObj.path || window.app?.$route?.fullPath || '';
    return this.$data._gMpShareObj;
  },
  methods: {
    /**
     * 获取图片腾讯url压缩图片（兼容小程序）
     * @param args
     * @returns {*}
     */
    getCompressImgUrl(...args) {
      // 如果url为空，显示默认加载图
      if (!args?.[0]) {
        return ConfigInfo.instance.getConfig().loadingImg;
      }
      const url = getCompressImgUrl(...args);
      return getCdnUrl(url);
    },
    /**
     * 初始化分享参数
     * @param obj { title: 分享标题，desc:描述（小程序没有）,icon:图片，link: H5链接，mpPath: 小程序path }
     */
    setShareParams(obj) {
      obj.isWzydShare = true;
      if (process.env.UNI_PLATFORM === 'mp-weixin' || process.env.UNI_PLATFORM === 'mp-qq') {
        if (this.$data._gMpShareObj) {
          this.$data._gMpShareObj.title = obj.title;
          this.$data._gMpShareObj.path = obj.mpPath;
          this.$data._gMpShareObj.imageUrl = obj.mpImageUrl;
        }
        return;
      }
      obj.link = addAdtag(obj.link);
      initShare(obj);
    },
    /**
     * 打开分享
     */
    openShare(shareParams = {}) {
      // 小程序都是通过button标签加open-type="share"实现直接分享给好友，并不需要这个提示，
      if (!this.isMPWeixin) {
        if (isInAcceleratorApp()) {
          clientShare({
            title: shareParams.title || '王者荣耀赛事',
            desc: shareParams.desc || '王者荣耀全民电竞办赛系统，一键办赛/参赛、智能AI解说直播、跨平台对战、全英雄铭文，赢下这一声喝彩！',
            imgUrl: shareParams.icon || 'https://image-1251917893.file.myqcloud.com/Esports/new/admin/icon-wzry.jpg',
            url: shareParams.link || window.location.href,
          });
        } else {
          openShareUI();
        }
      }
    },
    showToast(text, zIndex) {
      Toast.show(text, zIndex);
    },
    showSuccessToast(text, zIndex) {
      Toast.showSuccess(text, zIndex);
    },
    showFailToast(text, zIndex) {
      Toast.showFail(text, zIndex);
    },
    showLoading(text = '加载中...', zIndex) {
      Toast.showLoading(text, zIndex);
    },
    dismissLoading() {
      Toast.dismissLoading();
    },
    reportClick(secondChannel, eventId, childId = 'all', { teamId, scheId, battleId, elementId } = {}) {
      reportClick.call(this, secondChannel, eventId, childId, teamId, scheId, battleId, elementId);
    },
    reportPageExposure(secondChannel, childId = 'all', { teamId, scheId, battleId, elementId, eventId } = {}) {
      console.log('\x1B[32m%s\x1B[0m', `Exposing. SecondChannel: ${secondChannel}. ChildId: ${childId}.`, {
        teamId, scheId, battleId, elementId, eventId,
      });
      reportPageExposure.call(this, secondChannel, childId, teamId, scheId, battleId, elementId, eventId);
    },
    reportPageDuration(secondChannel, childId = 'all', { teamId, scheId, battleId, elementId, eventDuration } = {}) {
      reportPageDuration.call(this, secondChannel, childId, teamId, scheId, battleId, elementId, eventDuration);
    },
    reportCustomData(secondChannel, eventId, customData = {}) {
      reportCustomData.call(this, secondChannel, eventId, customData);
    },
    getUrlPath,
    g_key(prefix = '', str = '') {
      return `${prefix}-${str}`;
    },
    getRouteParamsObj() {
      let res = getPageOptions();
      // #ifdef H5
      res = {
        ...(this.$route?.query || {}),
        ...(this.$route?.params || {}),
      };
      // #endif

      return res;
    },
    getRouteQueryObj() {
      let res = getPageOptions();
      // #ifdef H5
      res = {
        ...(this.$route?.query || {}),
        ...(this.$route?.params || {}),
      };
      // #endif

      return res;
    },
    $goBack() {
      if (getCurrentPages().length === 1) {
        if (this.redirectCustomPrePath()) {
          return;
        }
        // #ifdef H5
        navigateData.setNavType('back');
        // #endif
        uni.redirectTo({
          url: '/views/index/index-home?disableSetNavType=1',
          disableSetNavType: true,
        });
      } else {
        uni.navigateBack({ delta: 1 });
      }
    },
    /**
     * 自定义返回按钮操作
     * @returns {boolean}
     */
    redirectCustomPrePath() {
      const pages = getCurrentPages();
      if (!pages.length) return false;
      const curPage = pages[pages.length - 1];
      let path;
      if (process.env.UNI_PLATFORM === 'h5') {
        path = curPage?.getNavigatorPreviousPath?.();
      } else {
        path = curPage?.$vm?.getNavigatorPreviousPath?.();
      }
      console.log('redirectCustomPrePath.path', path);

      if (path) {
        if (path === '/') {
          // #ifdef H5
          navigateData.setNavType('back');
          // #endif
          uni.redirectTo({
            url: '/views/index/index-home?disableSetNavType=1',
            disableSetNavType: true,
          });
          return true;
        }
        console.log('path', path);

        // #ifdef H5
        navigateData.setNavType('back');
        // #endif
        uni.redirectTo({
          url: path.includes('?') ? `${path}&disableSetNavType=1` : `${path}?disableSetNavType=1`,
          disableSetNavType: true,
        });
        // if (process.env.UNI_PLATFORM === 'h5') {
        //   navigateData.setNavType('back');
        // }
        return true;
      }
    },
    $destroy() {
      // 避免vue2 API报错
    },
  },
  mounted() {
    insertHorClass();
  },
  activated() {
    insertHorClass();
  },
};
